const Color = {
  black: '#2b2837',
  lightGrey: '#f6f7f8',
  midGrey: '#e7eaed',
  semiGrey: '#c6c9cc',
  aeGrey: '#AEAEAE',
  darkGrey: '#787b83',
  red: '#F64A3F',
  wrong: '#FF414D',
  magenta: '#FF336B',
  yellow: '#FDC013',
  pink: '#D23FF6',
  primaryBkg: 'white',
  primary: '#5843be',
  lightprimary: '#f6f4ff',
  lightblue: '#ecf6ff',
  blue: '#1a54af',
  dodgeBlue: '#1089FF',
  lightorange: '#ffece6',
  orange: '#fa5f1d',
  lightgreen: '#fffbf0',
  green: '#427a09',
  lightGreen: '#7ED321',
  seaGreen: '#28DF99',
  lightSeaGreen: '#69E9B8',
  backgroundGreen: '#E9FCF5',
  purple: '#5843be',
  lightpurple: '#f6f4ff',
  textOrange: '#FFA931',
  pinkRed: '#F50057',
  black:"#191919",
  lightBlack : "#636363",
  gray45:"#737373"
};

export default Color;
